export default __webpack_public_path__ + "static/media/prev.94cf13d9.svg";